import { useNavigate } from 'react-router-dom'
import { OnboardingFlow } from '../components/Auth/OnboardingFlow'
import { useAuthStore } from '../store/auth'

export function Onboarding() {
  const navigate = useNavigate()

  function handleComplete() {
    const username = useAuthStore.getState().username
    if (username) {
      useAuthStore.getState().setNeedsOnboarding()
      navigate('/welcome', { replace: true })
    } else {
      navigate('/login', { replace: true })
    }
  }

  return <OnboardingFlow onComplete={handleComplete} />
}
